import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService, ConfirmationService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private messageService: MessageService, private translate: TranslateService, private confirmationService: ConfirmationService) {}

  /**
   * Función para convertir los mensajes de error del backend
   * @param codigo cadena
   * @return string
   */
  mensaje(codigo: string): string {
    switch (codigo) {
      case 'NotNull':
        return 'no puede estar vacio.';
      case 'NotNumeric':
        return 'debe contener un valor numérico.';
      case 'MaxLength':
        return 'supera el límite de longitud permitido.';
      case 'MinValue':
        return 'debe ser mayor que el mínimo permitido.';
      default:
        return 'se encuentra en un estado invalido.';
    }
  }

  /**
   * Método para mostrar la alerta de confirmación
   * @param param objeto
   */
  confirm(confirmacionConfig: any): void {
    try {
      confirmacionConfig.key = confirmacionConfig.key ? this.translate.instant(confirmacionConfig.key) : 'app-confirmDialog';
      confirmacionConfig.header = this.translate.instant(confirmacionConfig.header);
      confirmacionConfig.message = this.translate.instant(confirmacionConfig.message);
      confirmacionConfig.icon = confirmacionConfig.icon ? this.translate.instant(confirmacionConfig.icon) : null;
      confirmacionConfig.acceptLabel = confirmacionConfig.acceptLabel ? this.translate.instant(confirmacionConfig.acceptLabel) : null;
      confirmacionConfig.rejectLabel = confirmacionConfig.rejectLabel ? this.translate.instant(confirmacionConfig.rejectLabel) : null;
      this.confirmationService.confirm(confirmacionConfig);
    } catch (error) {
      console.log(error);
      this.error(error);
    }
  }

  /**
   * Método para añadir una alerta de exito
   * @param msg cadena
   */
  success(msg?: string, translate?: boolean): void {
    this.add(msg, 'success', translate, 'ALERTA.exito');
  }

  /**
   * Método para añadir una alerta de error
   * @param msg cadena
   */
  error(msg?: string, translate?: boolean): void {
    this.add(msg, 'error', translate, 'ALERTA.error');
  }

  /**
   * Método para añadir una alerta de advertencia
   * @param msg cadena
   */
  warning(msg: string, translate?: boolean): void {
    this.add(msg, 'warn', translate);
  }

  /**
   * Método para añadir una alerta de información
   * @param msg cadena
   */
  info(msg: string, translate?: boolean): void {
    this.add(msg, 'info', translate);
  }

  add(msg: string, severity: string, translate?: boolean, defaultMsg: string = ''): void {
    let msgTranslate = null;

    if (typeof msg === 'string') {
      msgTranslate = translate ? this.translate.instant(msg) : msg;
    }
    this.messageService.add({ severity, detail: msgTranslate ? msgTranslate : this.translate.instant(defaultMsg) });
  }

  /**
   * Método para mostrar mensaje de error
   * @param msg cadena
   */
  exception(httpResponse: any): void {
    this.messageService.clear();
    let defer;    
    let msg = '';

    if (httpResponse.status || httpResponse.status === 0) {
      switch (httpResponse.status) {
        case -1:
          defer = this.error(this.translate.instant('ALERTA.error'));
          break;
        case 0:
          defer = this.error(this.translate.instant('ALERTA.error'));
          break;
        case 400:
          if (httpResponse.error.errorCampo) {
            for (const errorCampo of httpResponse.error.errorCampo) {
              msg += 'El campo ' + errorCampo.field + ' ' + this.mensaje(errorCampo.message) + ' ';
            }
          } else {
            if (httpResponse.error.mensaje) {
              msg = httpResponse.error.mensaje;
            } else {
              msg = httpResponse.error;
            }
          }
          defer = this.error(msg);
          break;
        case 404:
          if (httpResponse.error.errorCampo) {
            for (const errorCampo of httpResponse.error.errorCampo) {
              msg += 'El campo ' + errorCampo.field + ' ' + this.mensaje(errorCampo.message) + ' ';
            }
          } else {
            if (httpResponse.error.mensaje) {
              msg = httpResponse.error.mensaje;
            } else {
              msg = httpResponse.error;
            }
          }
          defer = this.error(msg);
          break;

        case 500:
          defer = this.error(httpResponse.error.mensaje);
          break;

        default:
          if (httpResponse && httpResponse.error.mensaje) {
            defer = this.error(httpResponse.error.mensaje);
          } else {
            defer = this.error('ALERTA.default', true);
          }
      }
    } else {
      defer = this.error(httpResponse);
    }
    return defer;
  }

  /**
   * Método que remueve las alertas
   */
  clear(): void {
    this.messageService.clear();
  }
}
